import type { CompositePrimaryKey, GlobalCollectionId, ResolvedMonospacePrimitiveField } from '#layers/data-model/public';
import { createContext } from 'reka-ui';

/** Picks items of a collection; each returned key carries the `selectionKeys` fields. */
export type OpenRelatedItemDrawer = (
	collectionId: GlobalCollectionId,
	options: { selection: CompositePrimaryKey[]; selectionKeys: ResolvedMonospacePrimitiveField[] },
) => Promise<CompositePrimaryKey[] | null>;

const [injectRelatedItemDrawer, provideRelatedItemDrawer] = createContext<OpenRelatedItemDrawer>('RelatedItemDrawer');

export { provideRelatedItemDrawer };

const openRelatedItemDrawerNoop: OpenRelatedItemDrawer = () => {
	if (import.meta.dev) {
		console.warn('[useRelatedItemDrawer] No related-item drawer provided; call provideRelatedItemDrawer() in the host. Related-item picking is disabled.');
	}

	return Promise.resolve(null);
};

export function useRelatedItemDrawer(): OpenRelatedItemDrawer {
	return injectRelatedItemDrawer(null) ?? openRelatedItemDrawerNoop;
}
